/*
* This would run first on each page and create a persistent cookie if one is not set
* as well as updating the session cookie for each page traversed.
* Once this has run, the secondary cookie data will overwrite items as necessary,
* such as the source and source location on partner/landing pages, or any other items.
*/

var trackingModule = new function() {
	// Allow/suppress window.debugLog statements for debugging
	this.debug = true;

	// How long the persistent cookie should exist for(in days)
	this.persistentCookieLength = 90;

	// For internal use - Decoded document referrer
	//by specifying /?referrer-test=https://www.google.com/
	//it will override any referrers that may have been set,
	//so we can test how things work with different referrers
	//the code for this is slightly lower in the document as
	//it makes use of getQueryString, which is not yet defined
	this.documentReferrer = '';

	/*
	 * List of strings to search for in referrers that should be categorized as
	 * SEO sources
	 */
	this.seoOrganics = [
		"www.google",
		"com.google.android.googlequicksearchbox",
		"www-800loanmart-com.cdn.ampproject.org", //Referrer when a user clicks inside an AMP page
		"bing.com/",
		"daum.net/",
		"eniro.se/",
		"naver.com/",
		"yahoo.com/",
		"msn.com/",
		"aol.com/",
		"lycos.com/",
		"ask.com/",
		"altavista.com/",
		"search.netscape.com/",
		"cnn.com/SEARCH/",
		"about.com/",
		"mamma.com/",
		"alltheweb.com/",
		"voila.fr/",
		"search.virgilio.it/",
		"baidu.com/",
		"alice.com/",
		"yandex.com/",
		"najdi.org.mk/",
		"aol.com/",
		"mamma.com/",
		"seznam.cz/",
		"search.com/",
		"wp.pl/",
		"online.onetcenter.org/",
		"szukacz.pl/",
		"yam.com/",
		"pchome.com/",
		"kvasir.no/",
		"sesam.no/",
		"ozu.es/",
		"terra.com/",
		"mynet.com/",
		"ekolay.net/",
		"rambler.ru/"
	];

	/*
	 * Items to look for in the query string and the keys to transform them in to
	 * So if 'pkw' is specified in the query string, serialize it into the cookie
	 * as 'PaidSearchKeyword'
	 */
	this.queryStringMapping = {
		"channel": "Channel",
		"source": "Source",
		"sourcelocation": "SourceLocation",
		"storekey": "StoreKey",
		"pkw": "PaidSearchKeyword",
		"lm_mkt": "AdditionalInfo", // Rick says: The field is used by paid marketing to pass in other tracking data
		"phone": "Phone"
	};

	/*
	 * Item to look for in the page level APM data.  If they exist, transform them
	 * from the specified key into the corresponding value.
	 * So data.setSource becomes newData.Source
	 */
	this.apmMapping = {
		"setSource": "Source",
		"setSourceLocation": "SourceLocation",
		"setStoreKey": "StoreKey"
	};

	// This is a simplistic version of an sprintf function in javascript
	if (!String.prototype.format) {
		String.prototype.format = function() {
			var args = arguments;
			return this.replace(/{(\d+)}/g, function(match, number) {
				return typeof args[number] != 'undefined' ? args[number] : match;
			});
		};
	}

	//polyfill for padstart from mdn
	//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
	//this targets IE primarily
	if (!String.prototype.padStart) {
	    String.prototype.padStart = function padStart(targetLength,padString) {
	        targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
	        padString = String((typeof padString !== 'undefined' ? padString : ' '));
	        if (this.length > targetLength) {
	            return String(this);
	        }
	        else {
	            targetLength = targetLength-this.length;
	            if (targetLength > padString.length) {
	                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
	            }
	            return padString.slice(0,targetLength) + String(this);
	        }
	    };
	}

	/*
	 * Debug helper function
	 * If debugging is off, it will no longer trigger the window.debugLog function
	 */
	this.log = function(data) {
		if(this.debug) {
			window.debugLog(data);
		}
	}

	// This just sets a cookie with a given name, value, and number of days
	// if exdays == 'session', then it's a session cookie
	this.setCookie = function(cname, cvalue, exdays) {
		if(exdays == 'session') {
			var cookieString = cname + "=" + cvalue + ";domain="+globalSiteSettings.cookieDomain+";path=/";
			document.cookie = cookieString;
			//this.log(cookieString);
		}else{
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+ d.toUTCString();
			var cookieString = cname + "=" + cvalue + ";" + expires + ";domain="+globalSiteSettings.cookieDomain+";path=/";
			document.cookie = cookieString;
			//this.log(cookieString);
		}
	}

	// Simple function to get a cookie and return undefined if it doesn't exist
	this.getCookie = function(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return undefined;
	};

	/*
	 * Clone of php's urldecode
	 */
	this.urldecode = function(url) {
		return decodeURIComponent(url.replace(/\+/g, ' '));
	}

	/*
	 * Format out the date in a specific format
	 */
	this.getCurrentDate = function() {
		var currentDate = new Date();
		// "5/2/2018 11:01:59 AM"
		var amPm = 'AM';
		var hours = currentDate.getUTCHours();
		if(hours >= 12) {
			if(hours != 12) {
			hours = hours - 12;
			}
			amPm = 'PM';
		}
		if(hours == 0) {
			hours = 12;
		}
		return "{0}/{1}/{2} {3}:{4}:{5} {6}".format(currentDate.getMonth()+1, currentDate.getDate()+1, currentDate.getFullYear(), String(hours).padStart(2, 0), String(currentDate.getUTCMinutes()).padStart(2, 0), String(currentDate.getUTCSeconds()).padStart(2, 0), amPm);
	};

	/*
	 * Get parts of the query string by key - not case sensitive
	 */
	this.getQueryString = function (name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i");
		var results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};

	this.documentReferrer = this.getQueryString('referrer-test');

	this.isDirectTraffic = function() {
		//if the query string is blank or null, use the browser
		//provided referrer
		if(this.documentReferrer == "" || this.documentReferrer == null) {
			this.documentReferrer = document.referrer;
		}

		//if we still don't have a referrer set, forcefully
		//assume it's direct/external even though it's blank
		if(this.documentReferrer == "") {
			//this.log('blank referrer!');
			return true;
		}

		return false;
	}

	/*
	 * Check and see if it's an external referrer
	 * This checks if
	 * * A testing override is set
	 * * The document referrer is set
	 * * The document referrer is empty
	 * * The referrer is for an external domain
	 */
	this.isExternalReferrer = function() {
		//we default to assuming the referrer is internal
		var isExternalReferrer = false;

		//check and see if the traffic is from a direct source or not
		if(this.isDirectTraffic()) {
			isExternalReferrer = true;
		}

		//we create a pseudo element and fill in it's href attribute
		//and then use .hostname on that element to compare it to the
		//current page's hostname.  this saves us from having to parse
		//out the url
		var tempHref = document.createElement("a");
		tempHref.href = this.documentReferrer;

		//regex for 800loanmart.com at the end of a hostname
		var hostnameRe = /800loanmart\.com$/;

		//check and see if the referrer is not an 800loanmart.com domain and if it doesn't match
		//the current window's hostname
		if(!hostnameRe.test(tempHref.hostname) && tempHref.hostname != window.location.hostname) {
			isExternalReferrer = true;
		}

		return isExternalReferrer;
	}

	/*
	 * Check and see if the lead comes from a known seo source
	 */
	this.isSeoLead = function() {
		//run this to 'bootstrap' the referrer info
		this.isExternalReferrer();

		if(this.documentReferrer !== undefined && this.documentReferrer.length > 0 && this.isExternalReferrer()) {
			for(var organicId in this.seoOrganics) {
				var organic = this.seoOrganics[organicId];
				if(this.documentReferrer.includes(organic)) {
					if(this.getQueryString('channel').length == 0) {
						return true;
					}
				}
			}
		}
		return false;
	}

	/*
	 * Get an object with the seo specific cookie data in it
	 * for merging in to our primary cookie data
	 */
	this.getSeoLeadData = function() {
		//if the document referrer is set, it's non-zero length, and it's marked as an external
		//we run through our list of seo organic search URLs and mark the source/channel as appropriate

		var seoLeadData = {};
		if(this.documentReferrer !== undefined && this.documentReferrer.length > 0 && this.isExternalReferrer()) {
			for(var organicId in this.seoOrganics) {
				var organic = this.seoOrganics[organicId];
				if(this.documentReferrer.includes(organic)) {
					switch(organic) {
					case 'www.google':
					case 'googlequicksearchbox':
					case 'www-800loanmart-com.cdn.ampproject.org'://classify AMP pages as Google organic sourced
						seoLeadData.SourceLocation = 'SEO_Google';
						break;
					case 'bing.com/':
						seoLeadData.SourceLocation = 'SEO_Bing';
						break;
					default:
						seoLeadData.SourceLocation = 'SEO_General';
						break;
					}
					seoLeadData.Source = 'SEO Website';
				}
			}
		}
		return seoLeadData;
	}

	/*
	 * Check and see if the page has defined any APM data
	 * and make sure that it's not empty APM data
	 */
	this.hasAPMTrackingData = function() {
		for(var key in this.apmMapping) {
			if(key in globalSiteSettings && globalSiteSettings[key].length > 0) {
				return true;
			}
		}
		//lpCookieData["Source"] = globalSiteSettings.setSource;
		//lpCookieData["SourceLocation"] = globalSiteSettings.setSourceLocation;
		//lpCookieData["StoreKey"] = globalSiteSettings.setStoreKey;
		return false;
	}

	/*
	 * Get the APM data from the page and map it accordingly
	 */
	this.getAPMTrackingData = function() {
		var trackingData = {};
		for(var key in this.apmMapping) {
			if(key in globalSiteSettings) {
				trackingData[this.apmMapping[key]] = globalSiteSettings[key];
			}else{
				trackingData[this.apmMapping[key]] = "";
			}
		}
		return trackingData;
	}

	/*
	 * Check if this is a first visit by checking to see if the
	 * 800LMTrackingPersistent cookie is set
	 */
	this.isFirstVisit = function() {
		//check for the existence of a persistent tracking cookie
		if(this.getCookie('800LMTrackingPersistent') === undefined) {
			return true;
		}
		return false;
	}

	/*
	 * Check and see if the query string has any data that we
	 * care about
	 */
	this.hasQueryStringData = function() {
		//iterate through each queryStringItems and check and see if they were specified
		//if they were, update/add the data to the cookie
		for(var item in this.queryStringMapping) {
			var qsItem = this.getQueryString(item);
			if(qsItem != "") {
				return true;
				//cookieData[queryStringItems[item]] = qsItem;
				//do the same, but only for source/sourcelocation/storekey for the landing page cookie
				if(this.queryStringMapping[item] == 'source' || this.queryStringMapping[item] == 'sourcelocation' || this.queryStringMapping[item] == 'storekey') {
					//lpCookieData[queryStringItems[item]] = qsItem;
				}
			}
		}
		return false;
	}

	/*
	 * Extract any meaningful query string data and return it
	 */
	this.getQueryStringData = function() {
		var queryStringData = {};
		for(var item in this.queryStringMapping) {
			var qsItem = this.getQueryString(item);
			if(qsItem != "") {
				queryStringData[this.queryStringMapping[item]] = qsItem;
			}
		}
		return queryStringData;
	}

	this.getAdditionalInfo = function(caseNumber) {
		var result = '';
		this.log('Case '+caseNumber);
		result = 'case='+caseNumber+"#version=2#referrer="+document.referrer;
		return result;
	}


	/*
	 * Cookie data starting point
	 * We can prepopulate it with some data that is known before pulling anything
	 * from the querystring
	 */
	var cookieData = {
		"Source": "",
		"SourceLocation": "",
		//"Channel": "",
		"Phone": globalSiteSettings.setPhone,
		"StoreKey": "",
		"CreationDate": this.getCurrentDate(),
		"EntryUrl": window.location.href,
		//"StartAppUrl": "",
		//"EndAppUrl": "",
		//"IpAdress": "",
		//"BrowserType": "",
		"UserAgent": navigator.userAgent,
		//"Region": "",
		"IsFirstTimeVisitor": (this.isFirstVisit() ? "Yes" : "No"),
		//"ExpirationDate": "",
		"Referrer": document.referrer,
	};

	var caseNumber = 0;

	this.log('Tracking Logic: Start');
	if(this.isDirectTraffic() && !this.hasQueryStringData() && this.isFirstVisit()) {
		if(this.hasAPMTrackingData()) {
			cookieData['AdditionalInfo'] = this.getAdditionalInfo('D0');
			//Populate LMLanding Page Cookie APM data
			this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
			this.log('800LMLandingPage set to...');
			this.log(this.getAPMTrackingData());

			//Populate 800LMPeresistent and 800LMSession cookies with user/web data & URL tracking info
			cookieData = $.extend(cookieData, this.getQueryStringData());
			this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
			this.log('800LMTrackingPersistent set to...');
			this.log(cookieData);

			this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
			this.log('800LMTrackingSession set to...');
			this.log(cookieData);
		}else{//doesn't have APM data
			cookieData['AdditionalInfo'] = this.getAdditionalInfo('D1');

			var defaultLPCookieData = {"Source": "seo_website", "SourceLocation": "direct_traffic", "StoreKey": ""};
			this.setCookie('800LMLandingPage', $.param(defaultLPCookieData), 'session');
			this.log('800LMLandingPage set to...');
			this.log(defaultLPCookieData);

			//Populate 800LMPeresistent and 800LMSession cookies with user/web data
			this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
			this.log('800LMTrackingPersistent set to...');
			this.log(cookieData);

			this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
			this.log('800LMTrackingSession set to...');
			this.log(cookieData);
		}
	} else if(this.isExternalReferrer()) {
		if(this.isSeoLead()) {
			if(this.getCookie('800LMLandingPage') === undefined) {
				if(this.hasAPMTrackingData()) {
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo('1A');
						//Populate LMLanding Page Cookie with APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo('1B');
						//Populate LMLanding Page Cookie with APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}else{//does not have APM data
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo('2A');
						//Populate LMLanding Page Cookie with SEO data
						this.setCookie('800LMLandingPage', $.param(this.getSeoLeadData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getSeoLeadData());

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo('2B');
						//Populate LMLanding Page Cookie with SEO data
						this.setCookie('800LMLandingPage', $.param(this.getSeoLeadData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getSeoLeadData());

						//Populate 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}
			}else{//cookie is not empty
				if(this.isFirstVisit()) {
					cookieData['AdditionalInfo'] = this.getAdditionalInfo(3);
					//Do NOT update LMLanding Cookie

					//Populate 800LMPeresistent and 800LMSession cookies with user/web data
					this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
					this.log('800LMTrackingPersistent set to...');
					this.log(cookieData);

					this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
					this.log('800LMTrackingSession set to...');
					this.log(cookieData);
				}else{//not first visit
					cookieData['AdditionalInfo'] = this.getAdditionalInfo(4);
					//Do NOT update LMLanding Cookie

					//Populate 800LMSession cookies with user/web data
					this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
					this.log('800LMTrackingSession set to...');
					this.log(cookieData);
				}
			}
		}else{//not an SEO lead
			if(this.hasQueryStringData()) {
				if(this.hasAPMTrackingData()) {
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(5);
						//Populate LMLanding Page Cookie APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data & URL tracking info
						cookieData = $.extend(cookieData, this.getQueryStringData());
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(6);
						//Populate LMLanding Page Cookie APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMSession cookies with user/web data & URL tracking info
						cookieData = $.extend(cookieData, this.getQueryStringData());
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}else{//does not have APM data
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(7);
						//Do NOT update LMLanding Cookie

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data & URL tracking info
						cookieData = $.extend(cookieData, this.getQueryStringData());
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(8);
						//Do NOT update LMLanding Cookie

						//Populate 800LMSession cookies with user/web data & URL tracking info
						cookieData = $.extend(cookieData, this.getQueryStringData());
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}
			}else{//does not have query string data
				if(this.hasAPMTrackingData()) {
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(9);
						//Populate LMLanding Page Cookie APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(10);
						//Populate LMLanding Page Cookie APM data
						this.setCookie('800LMLandingPage', $.param(this.getAPMTrackingData()), 'session');
						this.log('800LMLandingPage set to...');
						this.log(this.getAPMTrackingData());

						//Populate 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}else{//does not have APM data
					if(this.isFirstVisit()) {
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(11);
						//Do NOT update LMLanding Cookie

						//Populate 800LMPeresistent and 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingPersistent', $.param(cookieData), this.persistentCookieLength);
						this.log('800LMTrackingPersistent set to...');
						this.log(cookieData);

						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}else{//not first visit
						cookieData['AdditionalInfo'] = this.getAdditionalInfo(12);
						//Do NOT update LMLanding Cookie

						//Populate 800LMSession cookies with user/web data
						this.setCookie('800LMTrackingSession', $.param(cookieData), 'session');
						this.log('800LMTrackingSession set to...');
						this.log(cookieData);
					}
				}
			}
		}
	}
	this.log('Tracking Logic: End');

	window.debugLog('Resolving TrackingInformation');
	window.defTrackingInformation.resolve();
	return;
}
